module.exports = __webpack_public_path__ + "img/CouvertureInconnue.06293f56.png";